/** Render a list of the files that are being uploaded */
import * as React from 'react';
import { FlatList, type ListRenderItemInfo } from 'react-native';

import { ListItem } from '@gitbook/react-uikit';
import { Icon } from '@gitbook/spine-icons';
import { Button, type IconDefinition, LoadingIndicator, renderIcon } from '@gitbook/spine-react';

import type { PendingFile } from './types';

export function UploadFilesList(props: {
    fileIcon: IconDefinition;
    files: PendingFile[];
    setFiles: React.Dispatch<React.SetStateAction<PendingFile[]>>;
}) {
    const { fileIcon, files, setFiles } = props;

    const renderItem = React.useCallback(
        ({ item }: ListRenderItemInfo<PendingFile>) => {
            const onRemove = () => {
                setFiles((prev) => prev.filter((file) => file.key !== item.key));
            };

            return (
                <ListItem
                    layout="wide"
                    icon={renderIcon(fileIcon, { className: 'text-primary' })}
                    title={item.file.name}
                    buttons={[
                        item.uploaded || item.failed ? null : <LoadingIndicator size="medium" />,
                        item.failed ? (
                            <Button
                                kind="blank"
                                leadingIcon={<Icon.Alert className="text-danger-standout" />}
                                label="Failed to upload. Please try again."
                                iconOnly
                                onPress={onRemove}
                            />
                        ) : null,
                        <Button
                            kind="blank"
                            leadingIcon={Icon.X}
                            iconOnly
                            label="Remove"
                            onPress={onRemove}
                        />,
                    ]}
                />
            );
        },
        [fileIcon, setFiles]
    );

    return <FlatList data={files} renderItem={renderItem} />;
}
